<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard>
                <CCardHeader class="d-flex align-items-center flex-wrap justify-content-between pb-0 header-with-nav">
                    <strong>Статусы отправки push</strong>
                </CCardHeader>
                <CCardBody>
                    <CDataTable
                        class="push-statuses"
                        hover
                        :items="items"
                        :fields="fields">
                        <template #created_at="data">
                            <td>{{ formatDate(data.item.created_at) }}</td>
                        </template>
                        <template #started_at="data">
                            <td>{{ formatDate(data.item.started_at) }}</td>
                        </template>
                        <template #status="data">
                            <td>{{ PUSH_STATUS_TITLE[data.item.status] }}</td>
                        </template>
                        <template #percent="data">
                            <td style="width: 200px;">
                                <CProgress
                                    :value="data.item.percent"
                                    color="success"
                                    class="mt-1"
                                    :show-value="true"
                                    :show-percentage="true"
                                />
                            </td>
                        </template>
                        <template #customerIds="data">
                            <td>{{ data.item.customerIds }}</td>
                        </template>
                        <template #cancel="data">
                            <td>
                                <CButton
                                    v-if="canCanceled(data.item.status)"
                                    color="danger"
                                    @click="cancel(data.item.id)"
                                >Отменить</CButton>
                            </td>
                        </template>
                    </CDataTable>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';

    import { PUSH_STATUS, PUSH_STATUS_TITLE } from '@/utils/push'

    export default {
        name: 'PushStatuses',

        data() {
            return {
                PUSH_STATUS_TITLE,
                items: [],
                total: 1,
                timerId: null,
                selected: 'orders',
                fields: [
                    { key: 'title', label: 'Заголовок' },
                    { key: 'text', label: 'Текст' },
                    { key: 'started_at', label: 'Дата начала отправки' },
                    { key: 'customerIds', label: 'Пользователей в рассылке' },
                    { key: 'total', label: 'Токенов в рассылке' },
                    { key: 'sended', label: 'Отправлено успешно' },
                    { key: 'status', label: 'Статус' },
                    { key: 'percent', label: 'Прогресс' },
                    { key: 'cancel', label: '' }
                ],
            };
        },

        computed: {
        },

        watch: {
            activePage: 'loadData',
            selected: 'loadData'
        },

        mounted() {
            this.loadData();
            this.timerId = setInterval(this.loadData, 10000);
        },

        beforeDestroy() {
            clearInterval(this.timerId);
        },

        methods: {
            formatDate(date) {
                return moment(date).format('YYYY-MM-DD HH:mm');
            },
            loadData() {
                Vue.axios
                    .get('/push-statuses')
                    .then(resp => {
                        this.items = resp.data.results.map(item => ({
                            ...item,
                            customerIds: item.customerIds ? JSON.parse(item.customerIds).length : 0
                        }));
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки статусов. ' + err);
                    });
            },
            cancel(id) {
                Vue.axios
                    .delete(`/push-statuses/${id}`)
                    .then(resp => {
                        this.loadData();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка отмены отправки. ' + err);
                    });
            },
            canCanceled(status) {
                console.log(status);
                return [PUSH_STATUS.SUCCESS, PUSH_STATUS.FAIL, PUSH_STATUS.CANCELED].indexOf(status) < 0
            }
        },
    };
</script>

<style>
input.custom-datepicker {
  border: 1px solid;
  border-color: #d8dbe0;
  width: 100%;
}
.header-with-nav ul.nav.nav-tabs {
    border-bottom: 0;
}
.push-statuses .table td {
    vertical-align: middle;
}
</style>
